// Making Responsive Navbar

// router
import { useSelector } from 'react-redux';
import { useLocation, Link as RouterLink, Outlet } from 'react-router-dom';

import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Stack, Container, styled,useMediaQuery } from '@mui/material';
import useLocales from 'hooks/useLocales';
import LanguagePopover from 'layouts/dashboard/header/LanguagePopover';

// icons ,react
import { FaSignInAlt } from 'react-icons/fa';
import { BsPlusLg } from 'react-icons/bs';

// // routes
import { PATH_AUTH, PATH_PAGE } from 'routes/paths';
import Logo from 'components/Logo';

const drawerWidth = 240;

function DrawerAppBar(props) {
  const mediaQuery=useMediaQuery('(max-width:600px)')
  const userToken = useSelector((state) => state?.user?.user?.token);
  const { translate } = useLocales();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // sidebar
  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Box sx={{ my: 2, display: 'flex', justifyContent: 'center' }}>
        <Logo />
      </Box>
      <Divider />
      <List>
        <ListItem sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <LanguagePopover />
        </ListItem>
        <ListItem disablePadding sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="text" component={RouterLink} to={PATH_PAGE.about}>
            {translate('header.about')}
          </Button>
        </ListItem>
        <ListItem disablePadding sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button variant="text" component={RouterLink} to={PATH_PAGE.contact}>
            {translate('header.contact')}
          </Button>
        </ListItem>
        {!userToken ? (
          <ListItem disablePadding sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              variant="contained"
              size="small"
              disableElevation
              component={RouterLink}
              to={PATH_AUTH.login}
              sx={{
                my: 1,
                boxShadow: 'none',
              }}
            >
              <FaSignInAlt />
              &nbsp; {translate('header.sign_in')}
            </Button>
          </ListItem>
        ) : (
          <Button
            variant="contained"
            size="small"
            disableElevation
            component={RouterLink}
            to="/dashboard/links"
            sx={{
              my: 3,
              boxShadow: 'none',
            }}
          >
            <FaSignInAlt />
            &nbsp; {translate('biolink')}
          </Button>
        )}
        {!userToken && (
          <listItem style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              target="_self"
              variant="contained"
              disableElevation
              component={RouterLink}
              to={PATH_AUTH.register}
              size="small"
              sx={{
                my: 1,
                boxShadow: 'none',
              }}
            >
              <BsPlusLg fontSize="small" />
              &nbsp; {translate('header.sign_up')}
            </Button>
          </listItem>
        )}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box>
      <AppBar sx={{ background: 'background.default' }}>
        <Toolbar component="Box" sx={{ background: '#161A38' }}>
          <Container
            component="Box"
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingX: { xs: '2px' } }}
          >
            <Stack
              direction="row"
              sx={{
                display: { xs: 'flex', justifyContent: 'space-between', width: '100%', paddingX: '0px', sm: 'none' },
              }}
            >
              <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle}>
                <MenuIcon sx={{ color: 'primary.main' }} />
              </IconButton>
              {!mobileOpen ? <Logo to="/" /> : null}
            </Stack>

            <Box sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}>
              <Logo />
            </Box>
            <div id="google_element" />
            <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center',
            display:{xs:mobileOpen===true&&'none',}
            }}>
              <LanguagePopover />

              <Button variant="text" component={RouterLink} to={PATH_PAGE.about} sx={{ mr: '2px', display:{xs:'none',sm:'block', md:'block'} }}>
                {translate('header.about')}
              </Button>
              <Button variant="text" component={RouterLink} to={PATH_PAGE.contact} sx={{ mr: '15px', display:{xs:'none',sm:'block', md:'block'} }}>
                {translate('header.contact')}
              </Button>

              {!userToken ? (
                <Button
                  variant="contained"
                  size="small"
                  rel="noopener"
                  disableElevation
                  component={RouterLink}
                  to={PATH_AUTH.login}
                  sx={{
                    alignItems: 'center',
                    boxShadow: 'none',
                    mr: '20px',
                    display:{xs:'none',sm:'flex', md:'flex'}
                  }}
                >
                  <FaSignInAlt />
                  &nbsp; {translate('header.sign_in')}
                </Button>
              ) : (
                <Button
                  startIcon={<FaSignInAlt fontSize='small'/>}
                  variant="contained"
                  size="small"
                  rel="noopener"
                  disableElevation
                  component={RouterLink}
                  to="/dashboard/links"
                  // href="https://material-ui.com/store/items/minimal-dashboard/"
                  sx={{
                    boxShadow: 'none',
                      display:mediaQuery&&"none"
                  }}
                >
                 {translate('biolink')}
                </Button>
              )}
              {!userToken && (
                <Button
                  size="small"
                  variant="contained"
                  rel="noopener"
                  disableElevation
                  component={RouterLink}
                  to={PATH_AUTH.register}
                  sx={{
                    // marginLeft: 2,
                    alignItems: 'center',
                    boxShadow: 'none',
                    display:{xs:'none',sm:'flex', md:'flex'}
                  }}
                >
                  <BsPlusLg fontSize="small" />
                  &nbsp; {translate('header.sign_up')}
                </Button>
              )}
            </Stack>
          </Container>
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </Box>

      <Outlet />
    </Box>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
